module.exports = __webpack_public_path__ + "img/icon4.97c99084.png";